import { LeasingSeasonListItem } from '../types/leasingSeason.types'

/** Active (non-archived) seasons only — used for default selection / heal. */
export function activeSeasons(
    seasons: LeasingSeasonListItem[],
): LeasingSeasonListItem[] {
    return seasons.filter((s) => !s.is_archived)
}

/** Season flagged is_current, or newest by start_date when none is flagged. */
export function resolveEffectiveCurrentSeasonId(
    seasons: LeasingSeasonListItem[],
): number | null {
    const active = activeSeasons(seasons)
    if (!active.length) return null
    const flagged = active.find((s) => s.is_current)
    if (flagged) return flagged.id
    return active[0].id
}

export function isViewingEffectiveCurrentSeason(
    seasons: LeasingSeasonListItem[],
    selectedSeasonId: number | null | undefined,
): boolean {
    if (selectedSeasonId == null) return false
    const effectiveId = resolveEffectiveCurrentSeasonId(seasons)
    return effectiveId === selectedSeasonId
}
